let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7plkH")).then(() => parcelRequire('k8z39'));